<div #fullscreenContainer class="w-full h-full">
<div class="absolute bottom-0 left-0 w-full h-16 bg-primary-200 flex items-center px-4 gap-2">
    <div class="cursor-pointer  bg-gray-600 hover:bg-secondary w-14 h-10 rounded-md text-white flex items-center justify-center" (click)="returnToAnchor()">
        <span class="text-center leading-4">
            <img width="32" height="32" alt="icon" class="icon" [src]="'assets/images/icons/cube.svg'">
        </span>
    </div>


    <div class="cursor-pointer bg-gray-600 hover:bg-secondary w-14 h-10 rounded-md text-white flex items-center justify-center" (click)="toggleTrueSize()"><span class="text-center leading-4">
        @if(lamellaArea().demoSize) {
            {{ "DEMO_SIZE" | translate }}
        } @else {
            {{ "REAL_SIZE" | translate }}
        }
            </span>
    </div>

    <div class="cursor-pointer  bg-gray-600 hover:bg-secondary w-14 h-10 rounded-md text-white flex items-center justify-center" (click)="setRenderQuality('LOW')">
        <span class="text-center leading-4">
            Low-Res
        </span>
    </div>

    <div class="cursor-pointer bg-gray-600 hover:bg-secondary w-14 h-10 rounded-md text-white flex items-center justify-center" (click)="setRenderQuality('HIGH')">
        <span class="text-center leading-4">
                Hi-Res
        </span>
    </div>


   <div class="cursor-pointer bg-gray-600 hover:bg-secondary w-14 h-10 rounded-md text-white flex items-center justify-center" (click)="toggleFullScreen()">
       <span class="text-center leading-4">
               <svg fill="#ffffff" height="32px" width="32px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="-38.5 -38.5 461.97 461.97" xml:space="preserve" transform="matrix(1, 0, 0, 1, 0, 0)" stroke="#ffffff" stroke-width="9.62425"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#ff0000" stroke-width="3.849700000000001"></g><g id="SVGRepo_iconCarrier"> <g> <g id="Fullscreen_1_"> <path d="M372.939,216.545c-6.123,0-12.03,5.269-12.03,12.03v132.333H24.061V24.061h132.333c6.388,0,12.03-5.642,12.03-12.03 S162.409,0,156.394,0H24.061C10.767,0,0,10.767,0,24.061v336.848c0,13.293,10.767,24.061,24.061,24.061h336.848 c13.293,0,24.061-10.767,24.061-24.061V228.395C384.97,221.731,380.085,216.545,372.939,216.545z"></path> <path d="M372.939,0H252.636c-6.641,0-12.03,5.39-12.03,12.03s5.39,12.03,12.03,12.03h91.382L99.635,268.432 c-4.668,4.668-4.668,12.235,0,16.903c4.668,4.668,12.235,4.668,16.891,0L360.909,40.951v91.382c0,6.641,5.39,12.03,12.03,12.03 s12.03-5.39,12.03-12.03V12.03l0,0C384.97,5.558,379.412,0,372.939,0z"></path> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </g> </g></svg>
       </span>
   </div>


</div>






<div class="h-full w-full hidden fade-in" [class.bg-gray-200]="isInFullscreen()" #threejsContainer></div>

@if (loading) {
    <div class="loading-indicator">
        <p>Ladataan...</p>
    </div>
}

</div>